import {endpoint} from '~/api';
import {IApiToken, ICreatedApiToken} from '~/modules/Profile/models/ApiToken';
import {IUser} from '~/modules/Users/models/User';

export type {IApiToken, ICreatedApiToken};

export const fetchApiTokens = (): Promise<IApiToken[]> =>
    endpoint.get<IApiToken[]>('/api-tokens').then(r => r.data);

export const createApiToken = (name: string): Promise<ICreatedApiToken> =>
    endpoint.post<ICreatedApiToken>('/api-tokens', {name}).then(r => r.data);

export const deleteApiToken = (id: string): Promise<void> =>
    endpoint.delete(`/api-tokens/${id}`).then(() => undefined);

export const getAccessToken = (email: string, password: string): Promise<string> => endpoint.post<{ token: string }>(
    '/login',
    {
        login: email,
        password: password
    }
).then(response => response.data.token);

export const fetchCurrentUser = (): Promise<IUser> => endpoint.get<IUser>('/users/me').then(response => response.data);

export const changePassword = (current: string, next: string): Promise<boolean> => endpoint
    .post('/password/update', {current: current, next: next})
    .then(() => true);

export const recoveryPassword = (email: string): Promise<boolean> => endpoint.post('/password/forgot', {email: email})
    .then(() => true);

export const renewPassword = (email: string, exp: number, signature: string, password: string): Promise<boolean> => endpoint
    .post('/password/renew', {
        password: password,
        email: email,
        expires_at: exp,
        signature: signature
    }).then(() => true);
